import { forwardRef } from 'preact/compat'

import Icon from '@/components/snippets/icon/icon'

export const SearchInput = forwardRef(({ onInput, onClear, value }, ref) => {
  return (
    <div className="flex items-center w-full h-10 border rounded-full border-primary-blue md:max-w-96">
      <div className="flex items-center justify-center h-full aspect-1">
        <Icon id="search-simple" className="text-primary-blue" />
      </div>
      <input
        ref={ref}
        onInput={onInput}
        className="h-full px-2 text-xs font-medium field-input text-neutrals-secondary-grey"
        type="text"
        name="query"
        value={value}
        placeholder="Search for products, ranges and more"
      />
      <button type="button" className="underline btn btn-text-accent btn-sm" onClick={onClear}>
        Clear
      </button>
    </div>
  )
})
